/**
 * Bootstrap 5 toast auto-initialization.
 * Watches for .toast elements that appear in the DOM (e.g. via HTMX OOB swaps)
 * and automatically shows them.
 */

function showToast(el) {
    if (el._toastInitialized) return;
    el._toastInitialized = true;

    const toast = bootstrap.Toast.getOrCreateInstance(el);

    toast.show();

    // Clean up after hide
    el.addEventListener('hidden.bs.toast', () => {
        el.remove();
    });
}

function initAll(root) {
    const toasts = (root || document).querySelectorAll('.toast:not(.hide):not(.show)');
    toasts.forEach((el) => showToast(el));
}

// Auto-init on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => initAll());

// Re-init after HTMX swaps
document.body.addEventListener('htmx:afterSettle', (e) => {
    initAll(e.detail.target);
});

// Watch for dynamically added toasts via MutationObserver
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return;

            if (node.classList && node.classList.contains('toast')) {
                showToast(node);
            }

            // Check children too (for container swaps)
            const nested = node.querySelectorAll ? node.querySelectorAll('.toast:not(.hide):not(.show)') : [];
            nested.forEach((el) => showToast(el));
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});

// Export for manual use
window.initToasts = initAll;
